import { useEffect } from 'react';

export const useResizeClass = (debounceMs = 150) => {
  useEffect(() => {
    const root = document.documentElement;
    let resizeEndTimer: number | null = null;

    const onResize = () => {
      root.classList.add('is-resizing');
      if (resizeEndTimer !== null) {
        clearTimeout(resizeEndTimer);
      }
      resizeEndTimer = window.setTimeout(() => {
        root.classList.remove('is-resizing');
        resizeEndTimer = null;
      }, debounceMs);
    };

    window.addEventListener('resize', onResize, { passive: true });

    return () => {
      window.removeEventListener('resize', onResize);
      if (resizeEndTimer !== null) {
        clearTimeout(resizeEndTimer);
        resizeEndTimer = null;
      }
      root.classList.remove('is-resizing');
    };
  }, [debounceMs]);
};
